import AriaLiveRegion from './AriaLiveRegion';

export default AriaLiveRegion;
